/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import CommonObject from "@shared/CommonObject";


const actions = {
	clientsFetch(context, param) {
		return CommonObject.server.getClientList()
			.then(result => {
				context.commit('SET_CLIENTS', result);
			})
	},
	clientCreate(context, userProfile) {
		return CommonObject.server.createClientProfile(userProfile)
			.then(result => {
				context.commit('UPDATE_CLIENT', result);
			})
	},
	clientUpdate(context, userProfile) {
		return CommonObject.server.updateClientProfile(userProfile)
			.then(result => {
				context.commit('UPDATE_CLIENT', result);
			})
	},
	clientDelete(context, userProfile) {
		return CommonObject.server.deleteClientProfile(userProfile)
			.then(result => {
				context.commit('DELETE_CLIENT', result);
			})
	},

}

export default actions;
